import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col, Card, Button, Table, Form } from 'react-bootstrap';
import Footer from '../layout/Footer';
import FormModal from '../../Utils/FormModal';
import { Link, useNavigate } from "react-router-dom";
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import LeaveTableData from './leave-data.json';
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';
import LeaveApproval from './LeaveApproval';
import { toast } from 'react-toastify';
import { getFromAPI, postToAPI, deleteFromAPI, showAlert, putToAPI, formatDate } from '../../Utils/utils';

// Display only created_date_time (when the leave request was created) - no fallback
const formatLeaveRequestDate = (data) => {
  const raw = data?.created_date_time ?? data?.createdDateTime;
  if (!raw) return '';
  try {
    const formatted = formatDate(raw);
    return formatted && formatted !== 'Invalid Date' ? formatted : '';
  } catch {
    return '';
  }
};

export default function Leave() {
    const [leaveData, setLeaveData] = useState([]);
    const [reportToEmail, setReportToEmail] = useState("");
    const [reportToName, setReportToName] = useState("");
    const userEmail = localStorage.getItem('email');
    const userName = localStorage.getItem('firstname');
    const isAdmin = Number(localStorage.getItem('admin'));
    const loginPosition = localStorage.getItem('designation');
    const staffId = Number(localStorage.getItem('loggedInStaffId'));
    const [editId, setEditId] = useState('');
    const [adminLeaveData, setAdminLeaveData] = useState([]);
    const [filteredAdminLeaveData, setFilteredAdminLeaveData] = useState([]);
    const [annualLeaveDays, setAnnualLeaveDays] = useState(0);
    const [sickLeaveDays , setSickLeaveDays] = useState(0);
    const [casualLeaveDays, setCasualLeaveDays] = useState(0);
    const [paidLeaveDays, setPaidLeaveDays] = useState(0);
    const [formModalShow, setFormModalShow] = useState(false);
    const navigate = useNavigate();
    const [festivalLeave, setFestivalLeave] = useState([]);
    const [alternateSaturdayLeave, setAlternateSaturdayLeave] = useState([]);
    const [weekendLeaveOptions, setWeekendLeaveOptions] = useState([]);
    const [totalFestivalLeave, setTotalFestivalLeave] = useState(0);
    const [remainingFestivalLeave, setRemainingFestivalLeave] = useState(0);
    const [totalCasualLeave, setTotalCasualLeave] = useState(0);
    const [totalLeave, setTotalLeave] = useState(0);
    const [remainingLeave, setRemainingLeave] = useState(0);
    const [finalReportingToEmail, setFinalReportingToEmail] = useState();
    const [reportToId, setReportToId] = useState(0);
    const [finalReportingToId, setFinalReportingToId] = useState(0);
    const [supervisorName, setSupervisorName] = useState();
    const [openingBalance,setOpeningBalance] = useState(0);
    const [selectedMonth, setSelectedMonth] = useState(-1);
    const [selectedYearTeam, setSelectedYearTeam] = useState("All");

    const months = [
        { value: -1, label: 'All' },
        { value: 0, label: 'January' },
        { value: 1, label: 'February' },
        { value: 2, label: 'March' },
        { value: 3, label: 'April' },
        { value: 4, label: 'May' },
        { value: 5, label: 'June' },
        { value: 6, label: 'July' },
        { value: 7, label: 'August' },
        { value: 8, label: 'September' },
        { value: 9, label: 'October' },
        { value: 10, label: 'November' },
        { value: 11, label: 'December' }
    ];

    const initialLeaveData = {
        report_to_id: 0,
        final_report_to_id: 0,
        created_user_id: staffId,
        leaveEmployeeName: userName,
        leaveType: 'Casual Leave',
        leaveDes: '',
        leaveStartDate: '',
        leaveEndDate: '',
        leaveTotalDays: '',
        leave_report_to_name: '',
        leave_report_to_email: '',
        leaver_email: userEmail,
        leave_part_selection: '',
        leave_rejection_reason: '',
        leave_status: 'Pending',
        halfDayType: '',
        leave_balance: (totalLeave) - remainingLeave,
        FinalReporting_to: '',
        final_reportTo_name: '',
    };
    const [formData, setFormData] = useState(initialLeaveData);

    const fetchBranchAdminData = async () => {
        try {
            const staffResponse = await getFromAPI(`leave_data/?staffid=${staffId}`);
            if (staffResponse && staffResponse.staff_admin_data) {
                setReportToEmail(staffResponse.staff_admin_data.email);
                setReportToName(staffResponse.staff_admin_data.firstname);
                setReportToId(staffResponse.staff_admin_data.staffid);
                setFinalReportingToEmail(staffResponse.super_admin_data.email);
                setSupervisorName(staffResponse.super_admin_data.firstname);
                setFinalReportingToId(staffResponse.super_admin_data.staffid);
            }
        } catch (error) {
            console.error("Error fetching branch admin data:", error);
            return null;
        }
    };

    const fetchFestivalLeave = async () => {
        try {
            const response = await getFromAPI(`FtsFestivalLeave/`);
            if (response && Array.isArray(response)) {
                let totalLeaveDays = 0;
                let remainingLeaveDays = 0;
                const currentDate = new Date();

                response.forEach((leave) => {
                    const startDate = new Date(leave.start_date);
                    const endDate = new Date(leave.end_date);
                    const leaveDays = (endDate - startDate) / (1000 * 3600 * 24) + 1;
                    totalLeaveDays += leaveDays;

                    if (startDate > currentDate) {
                        const futureLeaveDays = (endDate - startDate) / (1000 * 3600 * 24) + 1;
                        remainingLeaveDays += futureLeaveDays;
                    }
                });

                setFestivalLeave(response);
                setTotalFestivalLeave(totalLeaveDays);
                setRemainingFestivalLeave(remainingLeaveDays);
            }
        } catch (error) {
            console.error("Error fetching festival leave:", error);
            return null;
        }
    };

    const fetchAlternateSaturdayLeave = async () => {
        try {
            const response = await getFromAPI(`FtsOptions/?name=leave_alternate_saturday`);
            if (response) {
                setAlternateSaturdayLeave(response);
            }
        } catch (error) {
            console.error("Error fetching alternate Saturday leave:", error);
            return null;
        }
    };

    const fetchWeekendLeave = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=manage_weekend');
            if (response) setWeekendLeaveOptions(response);
        } catch (error) {
            console.error("Error fetching weekend leave:", error);
            return null;
        }
    };

    const fetchCasualLeave = async () => {
        try {
            const [optionsResponse, openingBalanceResponse, staffResponse] = await Promise.all([
                getFromAPI('FtsOptions/?name=casual_leave'),
                getFromAPI(`FtsOpeningBalance/?staffId=${staffId}`),
                getFromAPI(`FtsStaff/?staffid=${staffId}`)
            ]);
    
            const opening_balance = Number(openingBalanceResponse[0]?.opening_leave);
            const totalLeaveValue = openingBalanceResponse?.[0]?.total_leave || Number(optionsResponse[0]?.value);
            
            const joiningDate = new Date(staffResponse[0].joining_date);
            const dayOfJoining = joiningDate.getDate();
            
            const isDateInFinancialYear = (date) => {
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                const currentMonth = currentDate.getMonth();
    
                let financialYearStart, financialYearEnd;
                if (currentMonth >= 3) {
                    financialYearStart = new Date(`${currentYear}-04-01`);
                    financialYearEnd = new Date(`${currentYear + 1}-03-31`);
                } else {
                    financialYearStart = new Date(`${currentYear - 1}-04-01`);
                    financialYearEnd = new Date(`${currentYear}-03-31`);
                }
                
                return date >= financialYearStart && date <= financialYearEnd;
            };
    
            let adjustedCasualLeave = Number(optionsResponse[0]?.value);
            if (!isNaN(joiningDate) && 
                isDateInFinancialYear(joiningDate) && 
                dayOfJoining > 1) {
                adjustedCasualLeave -= 1;
            }
            setTotalLeave(totalLeaveValue);
            setOpeningBalance(opening_balance)
            setTotalCasualLeave(adjustedCasualLeave);
        } catch (error) {
            console.error("Error fetching casual leave:", error);
            setTotalCasualLeave(0);
        }
    };

    const fetchLeaveData = async () => {
        try {
            const response = await getFromAPI(`FtsLeave/?staffId=${staffId}`);
            if (response) {
                setLeaveData(response);
                countLeaveStatuses(response);
            }
        } catch (error) {
            console.error("Error fetching leave data:", error);
            return null;
        }
    };

    const calculateFinancialYearLeave = (leaveData) => {
        const today = new Date();
        let currentYear = today.getFullYear();

        if (today.getMonth() < 3) {
            currentYear -= 1;
        }

        const financialYearStart = new Date(`${currentYear}-04-01`);
        const financialYearEnd = new Date(`${currentYear + 1}-03-31`);
    
        let totalLeaveConsumed = 0;
    
        leaveData.forEach((leave) => {
            const startDate = new Date(leave.leave_start_date);
            const endDate = new Date(leave.leave_end_date);

            if (isNaN(startDate) || isNaN(endDate)) return;
    
            let leaveDays = parseFloat(leave.leave_total_days);
            if (isNaN(leaveDays) || leaveDays < 0) return;
    
            if (startDate >= financialYearStart && startDate <= financialYearEnd) {
                totalLeaveConsumed += leaveDays;
            }
        });
    
        totalLeaveConsumed = isNaN(totalLeaveConsumed) ? 0 : Math.round(totalLeaveConsumed * 2) / 2;
        return totalLeaveConsumed;
    };

    const fetchLeaveDataForBalance = async () => {
        try {
            const response = await getFromAPI(`FtsLeave/?staffId=${staffId}&leave_type=Casual Leave&created_user_id=${staffId}`);
            if (Array.isArray(response) && response.length > 0) {
                const sortedData = response.slice().sort((a, b) => new Date(b.leave_start_date) - new Date(a.leave_start_date));
                let totalLeaveConsumed = 0;

                sortedData.forEach(leave => {
                    if (['Approved', 'Pending'].includes(leave.leave_status)) {
                        totalLeaveConsumed += parseFloat(leave.leave_total_days);
                    } else if (leave.leave_status === 'Partially Approved') {
                        // For partially approved leaves, use approved_days if available
                        const approvedDays = parseFloat(leave.approved_days || leave.leave_total_days);
                        totalLeaveConsumed += approvedDays;
                    }
                });

                setRemainingLeave(totalLeaveConsumed);
            } else {
                setRemainingLeave(0);
            }
        } catch (error) {
            console.error("Error fetching leave data for balance:", error);
            setRemainingLeave(0);
        }
    };

    const fetchAdminApprovedLeave = async () => {
    try {
        // Normalize login position
        const normalizedPosition = loginPosition?.toLowerCase();

        // Fetch data based on hierarchy
        const [adminResponse, superAdminResponse] = await Promise.all([
            getFromAPI(`FtsLeave/?report_to_id=${staffId}`),
            getFromAPI(`FtsLeave/?final_report_to_id=${staffId}`)
        ]);

        let allData = [];
        if (['admin', 'ceo', 'director'].includes(normalizedPosition)) {
            allData = await getFromAPI('FtsLeave/');
        }

        // Step 1: Merge all data arrays
        const mergedRawData = [
            ...(adminResponse || []),
            ...(superAdminResponse || []),
            ...(allData || [])
        ];

        // Step 2: Remove duplicates based on leaveEmployeeId
        const uniqueDataMap = new Map();

        mergedRawData.forEach(item => {
            uniqueDataMap.set(item.id, item);
        });

        const mergedData = Array.from(uniqueDataMap.values());
        setAdminLeaveData(mergedData);
        filterLeaveDataByMonth(mergedData, selectedMonth, selectedYearTeam);

     } catch (error) {
        console.error("Error fetching admin approved leave:", error);
        setAdminLeaveData([]);
        setFilteredAdminLeaveData([]);
     }
   };

    const getCurrentMonth = () => {
        const today = new Date();
        return today.getMonth();
    };

    const parseLeaveDate = (value) => {
        if (value == null || value === "") return new Date(NaN);
        const s = String(value).trim();
        const ddmmyyyy = s.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/);
        if (ddmmyyyy) {
            const [, dd, mm, yyyy] = ddmmyyyy;
            return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        }
        const parsed = new Date(s);
        return isNaN(parsed.getTime()) ? new Date(NaN) : parsed;
    };

    const splitLeaveByMonth = (leave, month, yearFilter) => {
        const startDate = parseLeaveDate(leave.leave_start_date ?? leave.leaveStartDate);
        const endDate = parseLeaveDate(leave.leave_end_date ?? leave.leaveEndDate);
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return [];

        const yearNum = yearFilter !== "All" && yearFilter !== undefined ? Number(yearFilter) : null;

        if (month === -1) {
            if (yearNum === null) return [leave];
            const leaveStartYear = startDate.getFullYear();
            const leaveEndYear = endDate.getFullYear();
            if (leaveStartYear <= yearNum && yearNum <= leaveEndYear) return [leave];
            return [];
        }

        const year = yearNum !== null ? yearNum : startDate.getFullYear();
        const monthStart = new Date(year, month, 1);
        const monthEnd = new Date(year, month + 1, 0);
        if (startDate > monthEnd || endDate < monthStart) return [];

        const allDates = [];
        let d = new Date(startDate.getTime());
        while (d <= endDate) {
            allDates.push(new Date(d));
            d.setDate(d.getDate() + 1);
        }
        const monthDates = allDates
            .map((date, idx) => ({ date, idx }))
            .filter(({ date }) => date.getMonth() === month && date.getFullYear() === year);
        if (monthDates.length === 0) return [];
        // Calculate leave_part_selection for this month
        const leave_part_selection = leave.leave_part_selection
            ? monthDates.map(({ idx }) => leave.leave_part_selection[idx])
            : Array(monthDates.length).fill('Full Day');
        // Calculate total hours and days
        const totalHours = leave_part_selection.reduce((total, part) => {
            if (part === 'Full Day') return total + 8;
            if (part === 'First Half' || part === 'Second Half') return total + 4;
            if (part === 'Weekend' || part === 'Holiday') return total;
            return total + 8;
        }, 0);
        const leaveTotalDays = (totalHours / 8).toFixed(1);
        // Format period
        const formatDate = (date) => {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };
        return [{
            ...leave,
            leave_start_date: formatDate(monthDates[0].date),
            leave_end_date: formatDate(monthDates[monthDates.length - 1].date),
            leaveTotalDays,
            leave_total_days: leaveTotalDays,
            leave_part_selection,
            _original_id: leave.id, // for action buttons
        }];
    };

    const filterLeaveDataByMonth = (data, month, yearFilter) => {
        if (month === -1 && (yearFilter === "All" || yearFilter === undefined)) {
            setFilteredAdminLeaveData(data);
            return;
        }
        let filtered = [];
        data.forEach(leave => {
            filtered = filtered.concat(splitLeaveByMonth(leave, month, yearFilter));
        });
        setFilteredAdminLeaveData(filtered);
    };

    useEffect(() => {
        const initializeData = async () => {
            await Promise.all([
                fetchBranchAdminData(),
                fetchFestivalLeave(),
                fetchAlternateSaturdayLeave(),
                fetchWeekendLeave(),
                fetchCasualLeave(),
                fetchLeaveData(),
                fetchLeaveDataForBalance(),
                fetchAdminApprovedLeave()
            ]);
        };
        initializeData();
    }, [staffId, totalCasualLeave]);

    useEffect(() => {
        filterLeaveDataByMonth(adminLeaveData, selectedMonth, selectedYearTeam);
    }, [selectedMonth, selectedYearTeam, adminLeaveData]);

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            leave_balance: casualLeaveDays,
        }));
    }, [casualLeaveDays]);

    const convertToFloat = (leaveString) => {
        if (typeof leaveString === 'number') return leaveString;
        const numericValue = parseFloat(leaveString.replace(/[^\d.-]/g, ''));
        return !isNaN(numericValue) ? numericValue : 0;
    };

    const countLeaveStatuses = (leaveData) => {
        let totalAnnualLeaves = 30;
        let totalPaidLeavePool = 10;
        let totalCasualLeavePool = parseInt(totalCasualLeave, 10);
        let totalSickLeavePool = 10;

        let usedPaidLeaveDays = 0;
        let usedCasualLeaveDays = 0;
        let usedSickLeaveDays = 0;

        leaveData.forEach(leave => {
            if (['Approved', 'Pending'].includes(leave.leave_status) || leave.leave_status === 'Partially Approved') {
                let leaveDurationInDays;
                
                if (leave.leave_status === 'Partially Approved') {
                    // For partially approved leaves, use approved_days
                    leaveDurationInDays = parseFloat(leave.approved_days || leave.leave_total_days);
                } else {
                    leaveDurationInDays = parseFloat(leave.leave_total_days);
                }

                if (isNaN(leaveDurationInDays)) return;

                switch (leave.leave_type) {
                    case 'Paid Leave':
                        if (totalPaidLeavePool >= leaveDurationInDays) {
                            usedPaidLeaveDays += leaveDurationInDays;
                            totalPaidLeavePool -= leaveDurationInDays;
                            totalAnnualLeaves -= leaveDurationInDays;
                        }
                        break;
                    case 'Casual Leave':
                        if (totalCasualLeavePool >= leaveDurationInDays) {
                            usedCasualLeaveDays += leaveDurationInDays;
                            totalCasualLeavePool -= leaveDurationInDays;
                            totalAnnualLeaves -= leaveDurationInDays;
                        }
                        break;
                    case 'Sick Leave':
                        if (totalSickLeavePool >= leaveDurationInDays) {
                            usedSickLeaveDays += leaveDurationInDays;
                            totalSickLeavePool -= leaveDurationInDays;
                            totalAnnualLeaves -= leaveDurationInDays;
                        }
                        break;
                    default:
                        break;
                }
            }
        });

        setPaidLeaveDays(Math.max(0, totalPaidLeavePool));
        setCasualLeaveDays(Math.max(0, totalCasualLeavePool));
        setSickLeaveDays(Math.max(0, totalSickLeavePool));
        setAnnualLeaveDays(Math.max(0, totalAnnualLeaves));
    };

    const handleLeaveModalOpen = () => {
        setEditId('');
        setFormModalShow(true);
        setFormData(initialLeaveData);
    };

    const handleFormModalClose = () => {
        setEditId('');
        setFormModalShow(false);
        setFormData(initialLeaveData);
    };

    const handleAddLeave = async () => {
        const staffDetails = await getFromAPI(`FtsStaff/?staffid=${staffId}`);
        if (!staffDetails || !staffDetails[0].joining_date) {
            return;
        }
        const joiningDate = new Date(staffDetails[0].joining_date);
        const leaveStartDate = new Date(formData.leaveStartDate);
        if (leaveStartDate < joiningDate) {
            toast.error("Leave start date cannot be before the joining date.");
            return;
        }
        const requestData = {
            staffId,
            leave_report_to_name: reportToName,
            leave_report_to_email: reportToEmail,
            created_user_id: staffId,
            leaver_email: userEmail,
            leave_status: 'Pending',
            leave_employee_name: formData.leaveEmployeeName,
            leave_type: formData.leaveType,
            leave_description: formData.leaveDes,
            leave_start_date: formData.leaveStartDate,
            leave_end_date: formData.leaveEndDate,
            leave_total_days: formData.leaveTotalDays,
            leave_part_selection: formData.leave_part_selection,
            leave_balance: formData.leave_balance,
            leave_rejection_reason: formData.leave_rejection_reason,
            FinalReporting_to: supervisorName,
            finalReporting_to_Email: finalReportingToEmail,
            report_to_id: reportToId,
            final_report_to_id: finalReportingToId,
            created_date_time: new Date().toISOString(),
        };

        try {
            const response = await postToAPI('FtsLeave/', requestData);
            if (response) {
                // Update leave balance when leave is applied
                const newRemainingLeave = Number(remainingLeave) + Number(formData.leaveTotalDays);
                setRemainingLeave(newRemainingLeave);
                
                toast.success('Leave Request Submitted Successfully');
                fetchLeaveData();
                setFormModalShow(false);
                setFormData(initialLeaveData);
            } else {
                toast.error('Leave Request Not Submitted');
            }
        } catch (error) {
            console.error("Error adding leave:", error);
            return null;
        }
    };

    const handleDeleteLeave = async (id) => {
        try {
            showAlert('Are you sure you want to delete this Leave?', 'confirm', (result) => {
                if (result) {
                    deleteLeave(id);
                }
            });
        } catch (error) {
            toast.error('Error deleting Leave');
        }
    };

    const deleteLeave = async (id) => {
        try {
            // Get leave details before deleting
            const leaveToDelete = leaveData.find(leave => leave.id === id);
            const response = await deleteFromAPI(`FtsLeave/${id}/`);
            if (response) {
                // Only revert leave balance if the leave was in Pending or Approved status
                if (leaveToDelete && ['Pending', 'Approved'].includes(leaveToDelete.leave_status)) {
                    const newRemainingLeave = Math.max(0, Number(remainingLeave) - Number(leaveToDelete.leave_total_days));
                    setRemainingLeave(newRemainingLeave);
                }
                
                // Update leaveData state immediately
                const updatedLeaveData = leaveData.filter(leave => leave.id !== id);
                setLeaveData(updatedLeaveData);
                
                // Update adminLeaveData and filteredAdminLeaveData states immediately
                const updatedAdminLeaveData = adminLeaveData.filter(leave => leave.id !== id);
                setAdminLeaveData(updatedAdminLeaveData);
                setFilteredAdminLeaveData(filteredAdminLeaveData.filter(leave => leave.id !== id));
                
                // Reinitialize DataTables with updated data
                if ($.fn.dataTable.isDataTable('#mainDatatableLeave')) {
                    $('#mainDatatableLeave').DataTable().destroy();
                }
                if ($.fn.dataTable.isDataTable('#mainDatatableLeaveList')) {
                    $('#mainDatatableLeaveList').DataTable().destroy();
                }
                
                toast.success('Leave deleted successfully!');
            } else {
                showAlert('Error deleting Leave', 'error');
            }
        } catch (error) {
            toast.error('Error deleting Leave');
        }
    };

    const updateModalContent = async (id) => {
        const data = leaveData.find((team) => String(team.id) === String(id));
        if (!data) return;

        const startDate = new Date(data.leave_start_date);
        const endDate = new Date(data.leave_end_date);
        const dateArray = [];
        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            dateArray.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        let leavePartSelections = data.leave_part_selection || [];
        const normalizedSelections = dateArray.map((_, index) =>
            leavePartSelections[index] || "Full Day"
        );

        const totalHours = normalizedSelections.reduce((total, part) => {
            if (part.toLowerCase() === "first half" || part.toLowerCase() === "second half") {
                return total + 4;
            } else if (part.toLowerCase() === "weekend") {
                return total + 0;
            }
            return total + 8;
        }, 0);

        const totalDays = (totalHours / 8).toFixed(1);

        setFormData({
            leaveEmployeeName: data.leave_employee_name,
            leaveType: data.leave_type,
            leaveEndDate: data.leave_end_date,
            leaveStartDate: data.leave_start_date,
            leaveTotalDays: totalDays,
            leave_part_selection: normalizedSelections,
            leaveDes: data.leave_description,
            leave_status: data.leave_status,
            leave_balance: data.leave_balance,
        });

        normalizedSelections.forEach((value, index) => {
            const element = document.getElementById(`leaveType_${index}`);
            if (element) element.value = value;
        });
    };

    const handleEditClick = (id) => {
        setFormModalShow(true);
        updateModalContent(id);
        setEditId(id);
    };

    const updateLeaveData = useCallback(async (itemDetails) => {
        const staffDetails = await getFromAPI(`FtsStaff/?staffid=${staffId}`);
        if (!staffDetails || !staffDetails[0].joining_date) {
            return;
        }
        const joiningDate = new Date(staffDetails[0].joining_date);
        const leaveStartDate = new Date(itemDetails.leaveStartDate);
        if (leaveStartDate < joiningDate) {
            toast.error("Leave start date cannot be before the joining date.");
            return;
        }

        const updateUrl = `FtsLeave/${editId}/`;
        const oldLeaveData = leaveData.find(leave => String(leave.id) === String(editId));
        
        const requestBody = {
            leave_report_to_name: reportToName,
            leave_report_to_email: reportToEmail,
            leaver_email: userEmail,
            created_user_id: staffId,
            leave_employee_name: itemDetails.leaveEmployeeName,
            leave_type: itemDetails.leaveType,
            leave_description: itemDetails.leaveDes,
            leave_start_date: itemDetails.leaveStartDate,
            leave_end_date: itemDetails.leaveEndDate,
            leave_total_days: itemDetails.leaveTotalDays,
            leave_status: itemDetails.leave_status,
            leave_part_selection: itemDetails.leave_part_selection,
            leave_balance: itemDetails.leave_balance,
            FinalReporting_to: supervisorName,
            finalReporting_to_Email: finalReportingToEmail,
            report_to_id: reportToId,
            final_report_to_id: finalReportingToId,
            leave_rejection_reason: itemDetails.leave_rejection_reason,
        };

        try {
            const response = await putToAPI(updateUrl, requestBody);
            if (response) {
                // Handle leave balance updates based on status changes and duration changes
                if (oldLeaveData) {
                    const oldStatus = oldLeaveData.leave_status;
                    const newStatus = itemDetails.leave_status;
                    const oldDays = Number(oldLeaveData.leave_total_days);
                    const newDays = Number(itemDetails.leaveTotalDays);
                    
                    // Calculate the difference in days
                    const daysDifference = newDays - oldDays;
                    
                    // Handle Partially Approved status specifically
                    if (newStatus === 'Partially Approved') {
                        // For Partially Approved, we need to consider the actual approved days
                        const approvedDays = Number(itemDetails.approved_days || newDays);
                        const newRemainingLeave = Number(remainingLeave) - (oldDays - approvedDays);
                        setRemainingLeave(Math.max(0, newRemainingLeave));
                    }
                    // Handle other status transitions
                    else if (['Pending', 'Approved', 'Partially Approved'].includes(oldStatus) && 
                        ['Pending', 'Approved'].includes(newStatus)) {
                        // If status changes between these states, adjust for day difference
                        const newRemainingLeave = Number(remainingLeave) + daysDifference;
                        setRemainingLeave(Math.max(0, newRemainingLeave));
                    } else if (['Pending', 'Approved', 'Partially Approved'].includes(oldStatus) && 
                              newStatus === 'Rejected') {
                        // If changing to Rejected, subtract all days from remaining
                        const newRemainingLeave = Number(remainingLeave) - oldDays;
                        setRemainingLeave(Math.max(0, newRemainingLeave));
                    } else if (oldStatus === 'Rejected' && 
                             ['Pending', 'Approved', 'Partially Approved'].includes(newStatus)) {
                        // If changing from Rejected, add the new days
                        const daysToAdd = newStatus === 'Partially Approved' ? 
                            Number(itemDetails.approved_days || newDays) : newDays;
                        const newRemainingLeave = Number(remainingLeave) + daysToAdd;
                        setRemainingLeave(Math.max(0, newRemainingLeave));
                    }
                }
                
                await fetchLeaveData();
                setFormModalShow(false);
                toast.success('Leave updated successfully!');
                setEditId('');
            }
        } catch (error) {
            toast.error('Cannot update leave request');
        }
    }, [editId, reportToName, reportToEmail, userEmail, staffId, supervisorName, finalReportingToEmail, reportToId, finalReportingToId, leaveData, remainingLeave]);

    const handleFormSubmit = () => {
        if (!formData.leaveStartDate) {
            toast.error('Please enter Start Date');
            return;
        }
        if (!formData.leaveEndDate) {
            toast.error('Please select End Date');
            return;
        }
        if (formData.leaveStartDate > formData.leaveEndDate) {
            toast.error('Start date should be before end date');
            return;
        }
        if (formData.leaveEmployeeName !== userName) {
            toast.error('Employee Name is not editable');
            return;
        }
    
        const totalHours = calculateTotalHours();
        const totalDays = (totalHours / 8).toFixed(1);
        if (formData.leaveTotalDays !== totalDays) {
            toast.error('Total days should not be edited manually');
            return;
        }
        if (totalDays === "0.0") {
            toast.error('Leave cannot be applied for only weekends/holidays');
            return;
        }
    
        const newStartDate = new Date(formData.leaveStartDate);
        const newEndDate = new Date(formData.leaveEndDate);
    
        const hasOverlap = leaveData.some((existingLeave) => {
            if (editId && String(existingLeave.id) === String(editId)) {
                return false;
            }
    
            const existingStartDate = new Date(existingLeave.leave_start_date);
            const existingEndDate = new Date(existingLeave.leave_end_date);
    
            if (existingLeave.leave_status !== 'Approved' && existingLeave.leave_status !== 'Pending') {
                return false;
            }
    
            return (
                newStartDate <= existingEndDate && newEndDate >= existingStartDate
            );
        });
    
        if (hasOverlap) {
            toast.error('A leave request already exists for the selected date range.');
            return;
        }
    
        if (!editId) {
            handleAddLeave();
        } else {
            updateLeaveData(formData);
        }
    };

    const handleMonthChange = (e) => {
        setSelectedMonth(Number(e.target.value));
    };

    const getYearOptionsTeam = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let y = currentYear + 1; y >= currentYear - 10; y--) years.push(y);
        return years;
    };

    const handleYearTeamChange = (e) => {
        setSelectedYearTeam(e.target.value === "All" ? "All" : Number(e.target.value));
    };

    useEffect(() => {
        return () => {
            if ($.fn.dataTable.isDataTable('#mainDatatableLeave')) {
                $('#mainDatatableLeave').DataTable().destroy();
            }
            if ($.fn.dataTable.isDataTable('#mainDatatableLeaveList')) {
                $('#mainDatatableLeaveList').DataTable().destroy();
            }
        };
    }, [leaveData, filteredAdminLeaveData]);

    const generateDateRange = useCallback(() => {
        if (!formData.leaveStartDate || !formData.leaveEndDate || !Array.isArray(alternateSaturdayLeave)) {
            return [];
        }

        const startDate = new Date(formData.leaveStartDate);
        const endDate = new Date(formData.leaveEndDate);
        if (isNaN(startDate) || isNaN(endDate)) return [];

        const dates = [];
        let currentDate = new Date(startDate);
        const alternateSaturdayData = parseInt(alternateSaturdayLeave[0]?.value, 10);
        const weekendDay = parseInt(weekendLeaveOptions[0]?.value, 10);

        if (isNaN(alternateSaturdayData) || isNaN(weekendDay)) return [];

        const getSaturdayPosition = (date) => Math.ceil(date.getDate() / 7);

        while (currentDate <= endDate) {
            dates.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        if (dates.length !== formData.leave_part_selection.length) {
            setFormData(prev => {
                const updatedLeavePartSelection = dates.map((date) => {
                    const dayOfWeek = date.getDay();
                    if (festivalLeave && festivalLeave.length > 0) {
                        const isFestivalHoliday = festivalLeave.some((festival) => {
                            const festivalStart = new Date(festival.start_date);
                            const festivalEnd = new Date(festival.end_date);
                            return date >= festivalStart && date <= festivalEnd;
                        });
                        if (isFestivalHoliday) return "Holiday";
                    }
                    if (dayOfWeek === weekendDay) return "Weekend";
                    if (dayOfWeek === 6) {
                        if (alternateSaturdayData === 2) return "Weekend";
                        const position = getSaturdayPosition(date);
                        if (
                            (alternateSaturdayData === 1 && (position === 2 || position === 4)) ||
                            (alternateSaturdayData === 0 && (position === 1 || position === 3))
                        ) return "Weekend";
                        if (alternateSaturdayData === 3) return "null";
                    }
                    return null;
                });

                return {
                    ...prev,
                    leave_part_selection: updatedLeavePartSelection,
                };
            });
        }

        return dates;
    }, [formData.leaveStartDate, formData.leaveEndDate, formData.leave_part_selection, alternateSaturdayLeave, festivalLeave, weekendLeaveOptions]);

    const handleInputChange = (index, field, value) => {
        if (field === "leaveType") {
            const leaveBalances = {
                "Casual Leave": casualLeaveDays,
                "Paid Leave": paidLeaveDays,
                "Sick Leave": sickLeaveDays,
            };
            const newLeaveBalance = leaveBalances[value] || 0;
            setFormData(prev => ({
                ...prev,
                leaveType: value,
                leave_balance: newLeaveBalance
            }));
        } else if (field === "leave_part_selection") {
            setFormData(prev => {
                const updatedLeavePartSelection = [...prev.leave_part_selection];
                updatedLeavePartSelection[index] = value;
                const numDates = generateDateRange().length;
                while (updatedLeavePartSelection.length < numDates) {
                    updatedLeavePartSelection.push(null);
                }
                return {
                    ...prev,
                    leave_part_selection: updatedLeavePartSelection,
                };
            });
        } else {
            setFormData(prev => ({
                ...prev,
                [field]: value,
            }));
        }
    };

    const leaveTableRowData = generateDateRange().map((date, index) => {
        const leavePartSelection = formData.leave_part_selection[index];
        let totalHours = '';
        if (leavePartSelection === 'Full Day') totalHours = '8 Hours';
        else if (leavePartSelection === 'First Half' || leavePartSelection === 'Second Half') totalHours = '4 Hours';
        else if (leavePartSelection === 'Weekend' || leavePartSelection === 'Holiday') totalHours = '0 Hours';
        else totalHours = '8 Hours';

        const isDisabled = leavePartSelection === "Weekend" || leavePartSelection === "Holiday";

        return {
            startDate: formatDate(date),
            leaveType: (
                <Form.Select
                    name={`leaveType_${index}`}
                    id={`leaveType_${index}`}
                    value={leavePartSelection || ''}
                    onChange={(e) => handleInputChange(index, "leave_part_selection", e.target.value)}
                    disabled={isDisabled}
                >
                    <option value="Full Day" disabled={isDisabled}>Full Day</option>
                    <option value="First Half" disabled={isDisabled}>First Half</option>
                    <option value="Second Half" disabled={isDisabled}>Second Half</option>
                    <option value="Weekend" disabled>Weekend</option>
                    <option value="Holiday" disabled>Holiday</option>
                </Form.Select>
            ),
            totalHours,
        };
    });

    const calculateTotalHours = () => {
        return leaveTableRowData.reduce((total, row) => {
            const hours = parseInt(row.totalHours.split(' ')[0], 10);
            return total + hours;
        }, 0);
    };

    useEffect(() => {
        const totalHours = calculateTotalHours();
        const totalDays = (totalHours / 8).toFixed(1);
        setFormData(prev => ({
            ...prev,
            leaveTotalDays: totalDays,
        }));
    }, [formData.leave_part_selection]);

    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#mainDatatableLeave')) {
            $('#mainDatatableLeave').DataTable({
                dom: "Bflrtip",
                pageLength: 25,
                buttons: [
                    {
                        extend: 'excel',
                        className: 'btn btn-outline-secondary',
                        text: `<svg viewBox="0 0 24 24" role="presentation" class="btn-icon me-1">
                                <path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z" style="fill: currentcolor;"></path>
                            </svg> Export to Excel`,
                        filename: 'myRetails_Leave',
                        title: 'myRetails Leave',
                    }
                ],
                data: leaveData.map((data) => [
                    data.leave_employee_name,
                    formatLeaveRequestDate(data),
                    data.leave_type,
                    `${formatDate(data.leave_start_date)} to ${formatDate(data.leave_end_date)}`,
                    data.leave_total_days,
                    data.leave_rejection_reason || "Not Available",
                    data.leave_status,
                    data.id,
                    data.leave_tokens
                ]),
                columns: [
                    { title: "Employee Name" },
                    { title: "Leave Request Date" },
                    { title: "Leave Type" },
                    { title: "Leave Period" },
                    { title: "Days/Hours Taken" },
                    { title: "Comment" },
                    {
                        title: "Leave Status",
                        render: function (data) {
                            const badgeClasses = {
                                'Pending': 'badge bg-soft-warning text-dark',
                                'Approved': 'badge bg-soft-success',
                                'Rejected': 'badge bg-soft-danger',
                                'Partially Approved': 'badge bg-soft-info',
                            };
                            return `<span class="${badgeClasses[data] || ''}">${data}</span>`;
                        }
                    },
                    {
                        title: "Action",
                        createdCell: function (td) {
                            td.classList.add('py-2');
                        },
                        render: function (data, type, row) {
                            const leaveStatus = row[6];
                            const isDisabled = ["Approved", "Rejected", "Partially Approved"].includes(leaveStatus);
                            return `
                                <div class="d-flex gap-2">
                                    <button class="btn btn-soft-info p-0 table-btn lkr-edit" data-id="${row[7]}" ${isDisabled ? "disabled" : ""}>
                                        <div class="avatar avatar-xs lkr-edit" data-id="${row[7]}">
                                            <svg viewBox="0 0 24 24" data-id="${row[7]}" role="presentation" class="avatar-icon lkr-edit">
                                                <path d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" style="fill: currentcolor;"></path>
                                            </svg>
                                        </div>
                                    </button>
                                    <button class="btn btn-soft-danger p-0 table-btn lkr-delete" data-id="${row[7]}" ${isDisabled ? "disabled" : ""}>
                                        <div class="avatar avatar-xs lkr-delete" data-id="${row[7]}">
                                            <svg viewBox="0 0 24 24" data-id="${row[7]}" role="presentation" class="avatar-icon lkr-delete">
                                                <path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" style="fill: currentcolor;"></path>
                                            </svg>
                                        </div>
                                    </button>
                                </div>`;
                        }
                    },
                ],
                autoWidth: false,
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });

            document.querySelector('#mainDatatableLeave tbody').addEventListener('click', (event) => {
                if (event.target.classList.contains('lkr-edit')) {
                    handleEditClick(event.target.getAttribute('data-id'));
                }
                if (event.target.classList.contains('lkr-delete')) {
                    handleDeleteLeave(event.target.getAttribute('data-id'));
                }
            });
        }

        if (!$.fn.dataTable.isDataTable('#mainDatatableLeaveList')) {
            $('#mainDatatableLeaveList').DataTable({
                dom: "Bflrtip",
                pageLength: 25,
                buttons: [
                    {
                        extend: 'excel',
                        className: 'btn btn-outline-secondary',
                        text: '<svg viewBox="0 0 24 24" role="presentation" class="btn-icon me-1"><path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z" style="fill: currentcolor;"></path></svg> Export to Excel',
                        filename: 'myRetails_Leave',
                        title: 'myRetails Leave'
                    }
                ],
                data: filteredAdminLeaveData.map((data) => [
                    data.leave_employee_name,
                    formatLeaveRequestDate(data),
                    data.leave_type,
                    `${formatDate(data.leave_start_date)} to ${formatDate(data.leave_end_date)}`,
                    data.leave_total_days,
                    data.leave_status,
                    data._original_id || data.id,
                    data.leave_tokens
                ]),
                columns: [
                    { title: "Employee Name" },
                    { title: "Leave Request Date" },
                    { title: "Leave Type" },
                    { title: "Leave Period" },
                    { title: "Days/Hours Taken" },
                    {
                        title: "Leave Status",
                        render: function (data) {
                            const badgeClass = {
                                'Pending': 'badge bg-soft-warning text-dark',
                                'Approved': 'badge bg-soft-success',
                                'Rejected': 'badge bg-soft-danger',
                                'Partially Approved': 'badge bg-soft-info'
                            }[data];
                            return `<span class="${badgeClass}">${data}</span>`;
                        }
                    },
                    {
                        title: "Action",
                        createdCell: function (td) {
                            td.classList.add('py-2');
                        },
                        render: function (data, type, row) {
                            return `<button class="btn btn-light leaveDetails" 
                                data-id="${row[6]}" 
                                data-leave_tokens="${row[7]}">Details</button>`;
                        }
                    },
                ],
                autoWidth: false,
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });

            const tableBody = document.querySelector('#mainDatatableLeaveList tbody');
            const handleRowClick = (event) => {
                if (event.target.classList.contains('leaveDetails')) {
                    const leaveId = event.target.getAttribute('data-id');
                    const token = event.target.getAttribute('data-leave_tokens');
                    navigate(`/leavedata/${leaveId}/${token}`);
                }
            };
            if (tableBody) {
                tableBody.addEventListener('click', handleRowClick);
            }
        }

        DataTable.Buttons.jszip(JSZip);
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
    }, [leaveData, filteredAdminLeaveData]);

    const rows = [
        {
            columns: [
                {
                    size: { lg: 12 },
                    label: <>Employee Name <span style={{ color: 'red' }}>*</span></>,
                    type: 'text',
                    name: 'leaveEmployeeName',
                    id: 'leaveEmployeeName',
                    placeholder: 'Enter title...',
                    value: formData.leaveEmployeeName,
                    readOnly: true,
                    disabled: true
                },
                {
                    size: { md: 12 },
                    label: <>Leave Type <span style={{ color: 'red' }}>*</span></>,
                    type: 'select',
                    name: 'leaveType',
                    id: 'leaveType',
                    value: formData.leaveType,
                    options: [
                        { value: "Casual Leave", label: "Casual Leave" },
                    ],
                },
                {
                    size: { md: 12 },
                    label: <>Leave Description <span style={{ color: 'red' }}>*</span></>,
                    type: 'textarea',
                    name: 'leaveDes',
                    formrow: '3',
                    id: 'leaveDes',
                    placeholder: 'Enter message...',
                    value: formData.leaveDes
                },
                {
                    size: { sm: 6, lg: 4 },
                    label: <>Start Date <span style={{ color: 'red' }}>*</span></>,
                    type: 'date',
                    name: 'leaveStartDate',
                    id: 'leaveStartDate',
                    placeholder: 'YYYY-DD-MM',
                    value: formData.leaveStartDate,
                    max: '9999-12-31',
                },
                {
                    size: { sm: 6, lg: 4 },
                    label: <>End Date <span style={{ color: 'red' }}>*</span></>,
                    type: 'date',
                    name: 'leaveEndDate',
                    id: 'leaveEndDate',
                    placeholder: 'YYYY-DD-MM',
                    value: formData.leaveEndDate,
                },
                {
                    size: { lg: 4 },
                    label: "Total Days",
                    type: "text",
                    name: "leaveTotalDays",
                    id: "leaveTotalDays",
                    placeholder: 'Total Days',
                    value: formData.leaveTotalDays,
                    readOnly: true,
                    disabled: true,
                },
                {
                    size: { sm: 6, lg: 4 },
                    label: 'Leave Balance',
                    type: 'text',
                    name: 'leaveBalance',
                    id: 'leaveBalance',
                    placeholder: 'Leave Balance',
                    value: formData.leave_balance,
                    readOnly: true,
                    disabled: true,
                },
                { type: 'table', tableSize: 'sm', thead: [], tbodydata: leaveTableRowData }
            ]
        }
    ];

    const isFormValid = () => {
        return (
            formData.leaveType &&
            formData.leaveDes &&
            formData.leaveStartDate &&
            formData.leaveEndDate &&
            formData.leaveTotalDays
        );
    };

    const Buttons = [
        { variant: "primary", text: "Ok", onClick: handleFormSubmit, disabled: !isFormValid() },
        { variant: "secondary", text: "Cancel", onClick: handleFormModalClose },
    ];

    // Add new function to calculate actual leave days for partially approved leaves
    const calculateActualLeaveDays = (leaveData) => {
        if (!leaveData || !leaveData.leave_part_selection) return 0;
        
        return leaveData.leave_part_selection.reduce((total, part) => {
            if (part === "Full Day") return total + 1;
            if (part === "First Half" || part === "Second Half") return total + 0.5;
            if (part === "Weekend" || part === "Holiday") return total;
            return total;
        }, 0);
    };

    // Add a new useEffect to update UI when leave data changes
    useEffect(() => {
        if (leaveData.length > 0) {
            countLeaveStatuses(leaveData);
            fetchLeaveDataForBalance();
        }
    }, [leaveData]);

    // Set default month to current month
    useEffect(() => {
        setSelectedMonth(getCurrentMonth());
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col xs={6} lg={6} className="mb-4">
                                <Card className="border border-success bg-soft-success text-center h-100">
                                    <Card.Body className="p-4">
                                        <h3 className="mb-3 fw-normal text-success">Available Leaves</h3>
                                        <h4 className="mb-2 fw-normal">{Number(totalLeave) - Number(remainingLeave)}</h4>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={6} lg={6} className="mb-4">
                                <Card className="border border-info bg-soft-info text-center h-100">
                                    <Card.Body className="p-4">
                                        <h3 className="mb-3 fw-normal text-info">Booked Leaves</h3>
                                        <h4 className="mb-2 fw-normal">{Number(remainingLeave || 0)}</h4>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {/* <Col xs={6} lg={3} className="mb-4">
                                <Link to="/festival_leave" style={{ textDecoration: 'none' }}>
                                    <Card className="border border-warning bg-soft-warning text-center h-100 cursor-pointer">
                                        <Card.Body className="p-4 d-flex flex-column justify-content-center">
                                            <h3 className="mb-3 fw-normal text-warning">Festival Leaves</h3>
                                            <div className="d-flex justify-content-center align-items-center gap-3">
                                                <h4 className="mb-2 fw-normal">{remainingFestivalLeave}/{totalFestivalLeave}</h4>
                                                <span className="d-inline-block py-1 rounded-1 bg-warning fw-normal fs-14 text-white">Available</span>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </Col> */}
                            {/* <Col xs={6} lg={3} className="mb-4">
                                <Card className="border border-danger bg-soft-danger text-center h-100">
                                    <Card.Body className="p-4">
                                        <h3 className="mb-3 fw-normal text-danger">Balance Leaves</h3>
                                        <h4 className="mb-2 fw-normal">{Number(totalLeave) - Number(remainingLeave)}</h4>
                                    </Card.Body>
                                </Card>
                            </Col> */}
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Card>
                                    <Card.Body>
                                        <div className='d-flex align-items-center justify-content-between mb-4'>
                                            <Card.Title className='mb-0'>My Leave Requests</Card.Title>
                                            <Button variant="light mb-sm-0 mb-3" onClick={handleLeaveModalOpen}>
                                                <Icon path={mdiPlus} className="btn-icon me-1" /> Add Leave
                                            </Button>
                                        </div>
                                        <Table responsive bordered className='table-nowrap' id='mainDatatableLeave'>
                                            <thead className='table-light'></thead>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        {isAdmin === 1 && (
                            <Row>
                                <Col md={12}>
                                    <Card>
                                        <Card.Body>
                                            <div className='d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2'>
                                                <Card.Title className='mb-0'>Team Leave Requests</Card.Title>
                                                <div className='d-flex align-items-center gap-2'>
                                                    <Form.Select 
                                                        value={selectedMonth}
                                                        onChange={handleMonthChange}
                                                        style={{ width: '140px' }}
                                                    >
                                                        {months.map(month => (
                                                            <option key={month.value} value={month.value}>
                                                                {month.label}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Select 
                                                        value={selectedYearTeam}
                                                        onChange={handleYearTeamChange}
                                                        style={{ width: '120px' }}
                                                    >
                                                        <option value="All">All Years</option>
                                                        {getYearOptionsTeam().map(y => (
                                                            <option key={y} value={y}>{y}</option>
                                                        ))}
                                                    </Form.Select>
                                                </div>
                                            </div>
                                            <Table responsive bordered className='table-nowrap' id='mainDatatableLeaveList'>
                                                <thead className='table-light'></thead>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        )}
                    </Container>
                </div>
                <Footer />
            </div>

            <FormModal
                title={editId ? "Edit Leave" : "Add Leave"}
                modalSize="lg"
                formModalShow={formModalShow}
                Buttons={Buttons}
                handleFormModalClose={handleFormModalClose}
                rows={rows}
                handleInputChange={handleInputChange}
                handleSubmit={handleFormSubmit}
            />
        </>
    );
}